export enum TransactionStatus {
	AUTHORIZED = 'authorized',
	CHARGEBACK = 'chargeback',
	CLOSED = 'closed',
	ERROR = 'error',
	EXPIRED = 'expired',
	PROCESSING = 'processing',
	REFUNDED = 'refunded',
	REFUSED = 'refused',
	TRIAL = 'trial',
	WAITING_PAYMENT = 'waiting_payment',
}

export enum OneClickBuyOutcome {
	Redirect = 'redirect',
	WaitingPix = 'waiting_pix',
	WaitingBankSlip = 'waiting_bank_slip',
	PendingCharge = 'pending_charge',
	Failure = 'failure',
}
